import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "@/Flowsheets/Models/CareElementFrequencyType";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

class SubjectCareElement extends BaseCareElement {
    public CareElementType: CareElementType.Subject;
    public IsScreened?: boolean | null;
    public IsNormal?: boolean | null;
    public DateReviewed?: Date | null;
    public LastReviewedDate?: Date | null;
    public Frequency?: CareElementFrequencyType;
    public DateReviewedWithPrecision?: DateTimeWithPrecision;
    public Notes: string;

    public constructor(init?: Omit<NonFunctionProperties<SubjectCareElement>, "CareElementType">) {
        super();
        this.Name = init?.Name ?? "";
        this.IsScreened = init?.IsScreened ?? null;
        this.IsNormal = init?.IsNormal ?? null;
        this.DateReviewed = init?.DateReviewed ?? null;
        this.LastReviewedDate = init?.LastReviewedDate ?? null;
        this.Frequency = init?.Frequency ?? null;
        this.Notes = init?.Notes ?? "";
        this.DateReviewedWithPrecision = init.DateReviewedWithPrecision ?? DateTimeWithPrecision.getDate(init?.DateReviewed);
        this.CareElementType = CareElementType.Subject;
    }
}

export { SubjectCareElement };
